import IconButton from "@mui/material/IconButton";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import CalendarViewMonthOutlinedIcon from "@mui/icons-material/CalendarViewMonthOutlined";
import { usePage } from "@hooks/usePage";

function MapTableSelector() {
  const { viewMode, setViewMode } = usePage();

  const handleIconClick = (icon: "map" | "table") => {
    setViewMode(icon);
  };
  return (
    <div className="flex items-center space-x-2">
      <IconButton onClick={() => handleIconClick("map")}>
        <MapOutlinedIcon
          className={`${viewMode === "map" ? "text-primary" : "text-accent"} h-8 w-8`}
        />
      </IconButton>
      <IconButton onClick={() => handleIconClick("table")}>
        <CalendarViewMonthOutlinedIcon
          className={`${viewMode === "table" ? "text-primary" : "text-accent"} h-8 w-8`}
        />
      </IconButton>
    </div>
  );
}

export default MapTableSelector;
